module.exports = __webpack_public_path__ + "img/blue_097.3e07d91a.png";